import React, { Component } from 'react'

import style from './style.css'

class Modal extends Component {

    state = {
        type: null,
        overflowY: 'auto'
    }

    constructor(props) {
        super(props)
        this.hide = this.hide.bind(this)

        this.body = document.body || document.documentElement
    }

    ignoreClose(e) {
        e.stopPropagation()
    }

    fixBody() {
        this.body.style.overflow = 'hidden'
    }

    unFixBody() {
        this.body.style.overflowY = this.state.overflowY
    }

    componentDidMount() {
        this.eventListener = function(evt) {
            var keyCode = evt.keyCode ? evt.keyCode :
                evt.charCode ? evt.charCode :
                evt.which ? evt.which : void 0
            if (keyCode === 27) {
                this.hide()
                evt.stopPropagation()
                evt.preventDefault()
            }
        }.bind(this)

        window.addEventListener('keydown', this.eventListener)
    }

    componentWillUnmount(){
        window.removeEventListener('keydown', this.eventListener)
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(nextProps) {
        var overflowY = this.body.style.overflowY
        if(nextProps.active && overflowY !== 'hidden') {
            this.fixBody()
            this.setState({
                type: 'controlled',
                overflowY
            })
        }

        if(this.state.type === 'controlled' && !nextProps.active) {
            this.unFixBody()
        }
    }

    hide(e) {
        if(this.props.handleClose) this.props.handleClose()
        if(e)
        e.stopPropagation()
    }

    render() {
        if(!this.props.active) return (<div />)


        return (
            <div>
                <div className={`${style.background} ${this.props.active ? style.active : ''}`} onClick={this.hide}>
                
                    <div className={`${style.modalContainer} ${this.props.full ? style.full : ''}`} onClick={this.hide}>
                        {!this.props.hideClose && (
                            <div className={style.modalClose} onClick={this.hide}>&#215;</div>
                        )}
                        <div className={style.modalTable}>
                            <div className={style.modalCell}>
                                <div
                                    className={style.modalContent}
                                    style={this.props.style}
                                    onClick={this.ignoreClose}
                                >
                                    {(this.props.loadContent === undefined || this.props.loadContent) && (
                                        <div>
                                            {this.props.children}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
        )
    }
}

export default Modal


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms-v2/Modal/index.js